import toString from "./component-library282.mjs";
import upperFirst from "./component-library235.mjs";
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}
export {
  capitalize as default
};
